import PropTypes from 'prop-types';
import React from 'react';

import ColorPicker from '../../../gd-components/color/color-picker/color-picker.jsx';

class ColorPickerFormElement extends React.Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,

        items: PropTypes.array,
        size: PropTypes.string.isRequired,
    };

    UNSAFE_componentWillMount() {
        this.props.form.registerFormComponent(this.props.name,this);
    }

    onChange = (newValue) => {
        this.props.form.onFormComponentValueChange(this.props.name,newValue);
    };

    render() {
        var value = this.props.form.getValue(this.props.name);

        return (
            <ColorPicker className={this.props.className}
                         size={this.props.size}
                         items={this.props.items}
                         value={parseInt(value)}
                         onChange={this.onChange} />
        );
    }
}

module.exports = ColorPickerFormElement;